export const ROUTE_HOME = 'ROUTE_HOME';
export const ROUTE_CATALOG_PAY = 'ROUTE_CATALOG-PAY';
export const ROUTE_PAYMENT_SERVICE_EMULATION = 'ROUTE_PAYMENT_SERVICE_EMULATION';
export const ROUTE_GET_ORDER = 'ROUTE_GET_ORDER';
export const ROUTE_PAYMENT_ERROR = 'ROUTE_PAYMENT_ERROR';
export const ROUTE_CARD_SELECT = 'ROUTE_CARD_SELECT';
export const ROUTE_PROFILE = 'ROUTE_PROFILE';

export const ROUTE_CARD_INFO = 'ROUTE_CARD_INFO';
export const ROUTE_CARD_HISTORY = 'ROUTE_CARD_HISTORY';
export const ROUTE_CARD_TARIFICATIONS = 'ROUTE_CARD_TARIFICATIONS';
export const ROUTE_CARD_SUBSCRIPTIONS = 'ROUTE_CARD_SUBSCRIPTIONS';

